import { createSlice } from "@reduxjs/toolkit";
export const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: { detail: null },
  reducers: {
    setUser: (state, action) => {
      state.detail = action.payload;
    },
    clearUser: (state) => {
      state.detail = null;
    },
  },
});
export const { setUser, clearUser } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
